import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

/**
 * Activities are pushed in from the Daily Tracker (see the tracker's
 * apps/timeclock/pip_sync.py) — this service is read-only, unlike
 * taskService/propertyService, since there is no create/update/delete UI
 * for an Activity in PIP itself.
 */
export const activityService = {
  listActivities: async (filters = {}) => {
    const response = await api.get(API_ENDPOINTS.ACTIVITIES.LIST, {
      params: filters,
    });
    return response.data;
  },
  listPropertyActivities: async (propertyId, filters = {}) => {
    const response = await api.get(API_ENDPOINTS.ACTIVITIES.BY_PROPERTY(propertyId), {
      params: filters,
    });
    return response.data;
  },
  listTaskActivities: async (taskId, filters = {}) => {
    const response = await api.get(API_ENDPOINTS.ACTIVITIES.BY_TASK(taskId), {
      params: filters,
    });
    return response.data;
  },
};

export default activityService;
